import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import Form from "../../components/form";
import AppContext from "../../container/context";

import { Button, CircularProgress, Fab, Stack, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DeleteIcon from "@mui/icons-material/Delete";

export default function PlanoAulas(props) {
  const [unidadeId] = useState(Number(props.match.params.id));
  const [unidade, setUnidade] = useState({});
  const [carregando, setCarregando] = useState(false);
  const [qtdAulas, setQtdAulas] = useState(0);
  const [listaAulas, setListaAulas] = useState([]);
  const [unidadeAulaId, setUnidadeAulaId] = useState("");
  const [listaFuncoes, setListaFuncoes] = useState([]);
  const { notification, confirm } = useContext(AppContext);

  useEffect(() => {
    carregar();
    carregarFuncoes();
    carregarAulas();
  }, []);

  const carregar = () => {
    setCarregando(true);

    api.get("unidades/carregar", { id: unidadeId }).then((res) => {
      setUnidade(res);
      setCarregando(false);
    });
  };

  const carregarFuncoes = () => {
    api.get("funcoes/listar").then((res) => {
      setListaFuncoes(res);
    });
  };

  const carregarAulas = () => {
    api
      .get("unidades/aulas/listar", { unidadeId })
      .then((res) => {
        setListaAulas(res);
      })
      .catch((err) => {
        console.log("erro", err);
      });
  };

  const fFiltros = {
    title: "Unidade",
    form: {
      cicloId: {
        label: "Ciclo",
        type: "text",
        readOnly: true,
        space: 4,
        value: unidade.cicloNome,
      },
      numero: {
        label: "Número",
        type: "number",
        space: 2,
        value: unidade.numero,
        readOnly: true,
      },
      sequencia: {
        label: "Sequência",
        type: "number",
        space: 2,
        value: unidade.sequencia,
        readOnly: true,
      },
      titulo: {
        label: "Título",
        type: "text",
        space: 4,
        value: unidade.titulo,
        readOnly: true,
      },
    },
  };

  const inserirQtdAulas = (qtd) => {
    api
      .post("unidades/aulas/inserir", {
        unidadeId: unidadeId,
        quantidade: qtd,
      })
      .then((res) => {
        notification("success", "Nova aula inserida");
        setQtdAulas(0);
        carregarAulas();
      })
      .catch((err) => {
        return notification("error", "Erro ao inserir quantidade de aulas");
      });
  };

  const fPlanos = {
    title: "Plano de aulas",
    form: {
      qtdAulas: {
        label: "Quantidade de aulas",
        type: "number",
        space: 12,
        value: qtdAulas,
      },
    },
    submit: {
      label: "Incluir aulas",
      action: (e) => {
        e.qtdAulas <= 0
          ? notification("warning", "Número de aulas inválido")
          : inserirQtdAulas(e.qtdAulas);
      },
    },
  };

  const salvarAula = (aulaEnviar) => {
    aulaEnviar.unidadeAulaId = unidadeAulaId;
    api
      .post("unidades/aulas/editar", aulaEnviar)
      .then((res) => {
        notification("success", "Dados de aula editado!");
        carregarAulas();
        setUnidadeAulaId("");
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Função responsável inválida");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const montarForm = (dados, index) => {
    if (dados.unidadeAulaId === unidadeAulaId) {
      return {
        form: {
          titulo: {
            label: "Título",
            type: "text",
            space: 4,
            value: dados.unidadeAulaTitulo
              ? dados.unidadeAulaTitulo
              : `(sem título)`,
          },
          responsavelFuncaoId: {
            label: "Responsável",
            type: "select",
            emptyItem: true,
            space: 4,
            array: {
              data: listaFuncoes,
              value: "id",
              desc: "nome",
            },
            value: dados.unidadeAulaResponsavelFuncaoId,
          },
          diasDuracao: {
            label: "Dias de duração",
            type: "number",
            space: 4,
            value: dados.unidadeAulaDiasDuracao,
          },
          descricao: {
            label: "Descrição",
            type: "textarea",
            space: 12,
            value: dados.unidadeAulaDescricao
              ? dados.unidadeAulaDescricao
              : "(sem descrição)",
          },
        },
        submit: {
          label: "Salvar",
          action: salvarAula,
        },
        close: {
          label: "cancelar",
          action: () => setUnidadeAulaId(""),
        },
      };
    } else {
      return {
        form: {
          unidadeAulaTitulo: {
            label: "Título",
            type: "text",
            space: 4,
            readOnly: true,
            value: dados.unidadeAulaTitulo
              ? dados.unidadeAulaTitulo
              : `(sem título)`,
          },
          unidadeAulaResponsavelFuncaoNome: {
            label: "Responsável",
            type: "text",
            space: 4,
            readOnly: true,
            value: dados.unidadeAulaResponsavelFuncaoNome,
          },
          unidadeAulaDiasDuracao: {
            label: "Dias de duração",
            type: "text",
            space: 4,
            readOnly: true,
            value: dados.unidadeAulaDiasDuracao,
          },
          unidadeAulaDescricao: {
            label: "Descrição",
            type: "textarea",
            space: 12,
            readOnly: true,
            value: dados.unidadeAulaDescricao
              ? dados.unidadeAulaDescricao
              : "(sem descrição)",
          },
        },
      };
    }
  };

  const removerAula = (item) => {
    const paramsEnviar = {
      unidadeId: unidadeId,
      unidadeAulaId: item.unidadeAulaId,
    };

    confirm({
      title: "Deseja realmente remover a aula?",
      label: "Não será possível desfazer esta ação.",
      onConfirm: () => {
        api
          .delete("unidades/aulas/remover", paramsEnviar)
          .then((res) => {
            notification("success", "Aula removida!");
            carregarAulas();
          })
          .catch((err) => {
            return notification("error", "Erro ao remover");
          });
      },
    });
  };

  const moverAula = (pos, item) => {
    const paramsEnviar = {
      unidadeId: unidadeId,
      unidadeAulaId: item.unidadeAulaId,
      novaPosicao: pos,
    };

    api
      .post("unidades/aulas/mover", paramsEnviar)
      .then((res) => {
        notification("success", "Ordem de aula alterada!");
        carregarAulas();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification(
              "error",
              "Posição inválida (deve ser entre 1 e a quantidade de aulas)"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  return (
    <div>
      <>
        {carregando ? (
          <CircularProgress />
        ) : (
          <>
            <Form formData={fFiltros} />
            {!listaAulas.length && <Form formData={fPlanos} />}

            {listaAulas.length > 0 && (
              <>
                {listaAulas.map((item, index) => (
                  <div
                    key={index}
                    style={{ background: "white", padding: 15, marginTop: 15 }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <h4>Aula {index + 1} </h4>{" "}
                      {unidadeAulaId !== item.unidadeAulaId && (
                        <Tooltip title="Editar">
                          <Fab
                            style={{ marginLeft: 10, color: "white" }}
                            size="small"
                            color="primary"
                            onClick={() => setUnidadeAulaId(item.unidadeAulaId)}
                          >
                            <EditIcon size="small" />
                          </Fab>
                        </Tooltip>
                      )}
                    </div>
                    <Form formData={montarForm(item, index)} />
                    <Stack spacing={2} direction="row" justifyContent={"end"}>
                      {listaAulas.length > 1 && (
                        <>
                          {index > 0 && (
                            <Button
                              style={{ color: "white" }}
                              variant="contained"
                              color="info"
                              onClick={() =>
                                moverAula(item.unidadeAulaOrdem - 1, item)
                              }
                            >
                              <ArrowUpwardIcon />
                            </Button>
                          )}

                          {index + 1 !== listaAulas.length && (
                            <Button
                              style={{ color: "white" }}
                              variant="contained"
                              color="info"
                              onClick={() =>
                                moverAula(item.unidadeAulaOrdem + 1, item)
                              }
                            >
                              <ArrowDownwardIcon />
                            </Button>
                          )}
                        </>
                      )}

                      <Button
                        style={{ color: "white" }}
                        variant="contained"
                        color="secondary"
                        onClick={() => removerAula(item)}
                      >
                        <DeleteIcon />
                      </Button>
                    </Stack>
                  </div>
                ))}
                <div style={{ marginTop: 15, textAlign: "end" }}>
                  <Button
                    style={{ color: "white" }}
                    variant="contained"
                    color="info"
                    onClick={() => inserirQtdAulas(1)}
                  >
                    + Nova aula
                  </Button>
                </div>
              </>
            )}
          </>
        )}
      </>
    </div>
  );
}
